/** Technický sloupec s interním ID záznamu (naše ID objektu v Mapiu). */
export const GRID_INTERNAL_ID_FIELD = 'id';

/** Prefix aliasu pro atribut, jehož název koliduje s {@link GRID_INTERNAL_ID_FIELD}. */
const CONFLICTING_ALIAS_PREFIX = 'attr_';

/**
 * Vrátí název pole v gridu (sloupec i filtr) pro daný název atributu vrstvy.
 * Musí odpovídat serverové metodě {@code MapioDataGridService.gridAlias}.
 */
export const gridFieldName = (nazevAtributu: string): string =>
    nazevAtributu?.toLowerCase() === GRID_INTERNAL_ID_FIELD ? `${CONFLICTING_ALIAS_PREFIX}${nazevAtributu}` : nazevAtributu;
